import env from '@/utils/env'
import web from './web'

/* global uni */

// 小程序webview登录页
export default {
  login({target_url} = {}) {
    if (uni) {
      return new Promise(() => {
        let isReplace = target_url == window.location.href ? true : false
        let ru = target_url || window.location.href

        env.uniAppJsReady.then(() => {
          if (isReplace) {
            uni.redirectTo({
              url: `/pages/web-view/login?url=${encodeURIComponent(`${ru}`)}`,
            })
          } else {
            uni.navigateTo({
              url: `/pages/web-view/login?url=${encodeURIComponent(`${ru}`)}`,
            })
          }
        })
      })
    } else {
      return web.login({target_url})
    }
  },

  logout() {
    return web.logout();
  },

  getToken() {
    return web.getToken();
  },

  refreshToken() {
    return web.refreshToken();
  }
}



// WEBPACK FOOTER //
// ./src/auth/miniprogram.js